module.exports = __webpack_public_path__ + "img/5.13c1f9d1.png";